import { Input } from '@storeblocks/input';
import { useField } from 'formik';
import { type FC } from 'react';

import { useTexts } from '@/hooks/useTexts';
import { nameof } from '@/util/nameof';

import { FormValues } from '../types/FormValues';

export const PepReason: FC = () => {
  const texts = useTexts();

  const [field, meta] = useField<string>(nameof<FormValues>('pepReason'));

  return (
    <Input
      {...field}
      id="pep-reason"
      label={texts.orders.signatureRight.pep.reason.title}
      hint={{ text: texts.orders.signatureRight.pep.reason.description }}
      alert={{
        messageType: meta.touched && meta.error ? 'error' : undefined,
        message: meta.error,
      }}
      fluid
    />
  );
};
